<div class="customer-type-label">{{!isPrimary ? 'CRP TYPE' : 'CUSTOMER TYPE'}}</div>
<artemis-button-toggle class="customer-button-toggle" [disabled]="data ? '': null" [(ngModel)]="customerType" (change)="changeToggleType()">
  <artemis-button-toggle-item value="INDIVIDUAL"> {{ 'customer_type.individual.title' | translate }} </artemis-button-toggle-item>
  <artemis-button-toggle-item value="CORPORATE"> {{ 'customer_type.corporate.title' | translate }} </artemis-button-toggle-item>
</artemis-button-toggle>
<!-- Start details forms -->
<div class="details-form__hint">
  {{ 'edit_customer.note' | translate }} (<span class="details-form__hint-asterisk">*</span>). {{ 'edit_customer.unknown' | translate }}
</div>
<!-- Start individual details forms -->
<form class="details-form" [formGroup]="individualFormGroup" [class.details-form_hidden]="customerType !== 'INDIVIDUAL' || !individualFormGroup">
  <!-- Start Is Active checkbox -->
  <div class="details-form__checkbox-container" *ngIf="isPrimary">
    <mat-checkbox class="custom-mat-checkbox details-form__checkbox" formControlName="isActiveCustomer"></mat-checkbox>
    <span class="details-form__checkbox-label" [ngClass]="{'details-form__checkbox-label_checked': individualFormGroup.get('isActiveCustomer').value}">
      {{ 'edit_customer.title.customer_is_active' | translate }} <span class="asterisk_mandatory">*</span>
    </span>
  </div>
  <!-- End Is Active checkbox -->
  <!-- Start Salutation formfield -->
  <mat-form-field class="custom-mat-form-field details-form__field details-form__field_title">
    <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-select placeholder="{{ 'customer_type.individual.form.label.salutation' | translate }}" formControlName="title">
      <mat-option *ngFor="let title of titlesList" [value]="title" [title]="title">
        {{title}}
      </mat-option>
    </mat-select>
    <mat-error *ngIf="individualFormGroup.get('title').errors?.incorrect && (individualFormGroup.get('title').dirty || individualFormGroup.get('title').touched)">
      <span *ngIf="individualFormGroup.get('title').errors?.incorrect">
        "{{individualFormGroup.get('title').value}}" {{ 'customer_type.individual.message.error.salutation' | translate }}
      </span>
      <span class="details-form__remove-error-value-label" (click)="removeValue(individualFormGroup.get('title'))" title="Remove">
        {{ 'customer_type.individual.message.error.remove' | translate }}
      </span>
    </mat-error>
  </mat-form-field>
  <!-- End Salutation formfield -->
  <!-- Start Name formfield -->
  <mat-form-field class="custom-mat-form-field custom-mat-form-field_mandatory details-form__field details-form__field_individual-name"
                  *ngIf="!isSearch; else individualExistingRecord;">
    <input matInput placeholder="{{ 'customer_type.individual.form.label.full_name' | translate }}" formControlName="name" autocomplete="off">
  </mat-form-field>
  <ng-template #individualExistingRecord>
    <mat-form-field class="custom-mat-form-field custom-mat-form-field_mandatory details-form__field details-form__field_individual-name" *ngIf="customerType === 'INDIVIDUAL'">
      <input matInput #individualNameInput='matInput' placeholder="{{ 'customer_type.individual.form.label.full_name' | translate }}" formControlName="name" [matAutocomplete]="individualName" [ngClass]="{'details-form__input_with-remove-btn': showRemoveBtn}">
      <button mat-button ubi-round-button class="btn btn_rounded remove-search-btn" *ngIf="showRemoveBtn" (click)="removeSelectedCustomer()">
        {{ 'customer_type.button.clear_selected_profile' | translate }}
      </button>
      <mat-autocomplete class="custom-mat-autocomplete search-name-autocomplete" #individualNameInfinity="infinityScroll" #individualName="matAutocomplete" [infinityModel]="individualNameInput" [infinityScroll]="recordsSuggest" (scrollRecordSearch)="onScroll($event)" [isRecordSearch]="true">
        <div class="search-option__hint" *ngIf="recordsSuggest && recordsSuggest.length">
          {{ 'customer_type.individual.hint' | translate }}
        </div>
        <mat-option *ngFor="let record of individualNameInfinity.items | async" [value]="record.name" (onSelectionChange)="optionSelected(record)">
          <div class="search-option__content">
            <div class="search-option__item">
              <label class="search-option__item-label"> {{ 'customer_type.individual.dropdown.name' | translate }} </label>
              <span class="search-option__item-text">{{record.name}}</span>
            </div>
            <div class="search-option__group">
              <div class="search-option__item search-option__group-item">
                <label class="search-option__item-label"> {{ 'customer_type.individual.dropdown.alias_name' | translate }} </label>
                <span class="search-option__item-text">{{record?.aliasNames?.length ? record.aliasNames.join(', ') : '-'}}</span>
              </div>
              <div class="search-option__item search-option__group-item">
                <label class="search-option__item-label"> {{ 'customer_type.individual.dropdown.reference_id' | translate }} </label>
                <span class="search-option__item-text">{{record.referenceId ? record.referenceId : '-'}}</span>
              </div>
            </div>
            <button mat-button ubi-round-button class="btn btn_accent-gradient-rounded btn-profile">
              {{ 'customer_type.individual.dropdown.use_this_profile' | translate }}
            </button>
          </div>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </ng-template>
  <!-- End Name formfield -->
  <!-- Start Alias Name multiple values input -->
  <artemis-multiple-values-input class="details-form__field" name="{{ 'customer_type.individual.form.label.alias_name' | translate }}" formControlName="aliasNames"
                                 (formSubmitted)="individualFormMultipleValuesInputHandler($event, 'aliasNames')" #multipleValuesInputComponent>
  </artemis-multiple-values-input>
  <!-- End Alias Name multiple values input -->
  <!-- Start Former Registered Name multiple values input -->
  <artemis-multiple-values-input class="details-form__field" name="{{ 'customer_type.individual.form.label.former_registered_name' | translate }}" formControlName="oldNames"
                                 (formSubmitted)="individualFormMultipleValuesInputHandler($event, 'oldNames')" #multipleValuesInputComponent>
  </artemis-multiple-values-input>
  <!-- End Former Registered Name multiple values input -->
  <!-- Start Gender formfield -->
  <mat-form-field class="custom-mat-form-field custom-mat-form-field_mandatory details-form__field">
    <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-select placeholder="{{ 'customer_type.individual.form.label.gender' | translate }}" formControlName="gender">
      <mat-option *ngFor="let gender of gendersList" [value]="gender" [title]="gender">
        {{gender}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- End Gender formfield -->
  <!-- Start Nationality formfield -->
  <mat-form-field class="custom-mat-form-field custom-mat-form-field_mandatory custom-mat-form-field_autocomplete details-form__field">
    <input matInput placeholder="{{ 'customer_type.individual.form.label.nationality' | translate }}" aria-label="Nationality *" [matAutocomplete]="nationality" formControlName="nationality">
    <img matSuffix class="custom-mat-autocomplete__arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-autocomplete #nationality="matAutocomplete" class="custom-mat-autocomplete">
      <mat-option *ngFor="let nationality of filteredIndividualNationalities$ | async" [value]="nationality" [title]="nationality">
        {{nationality}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <!-- End Nationality formfield -->
  <!-- Start Residence Country formfield -->
  <mat-form-field class="custom-mat-form-field custom-mat-form-field_mandatory custom-mat-form-field_autocomplete details-form__field">
    <input matInput placeholder="{{ 'customer_type.individual.form.label.country_of_residence' | translate }}" aria-label="Country of Residence *" [matAutocomplete]="countryOfResidence" formControlName="countryOfResidence">
    <img matSuffix class="custom-mat-autocomplete__arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-autocomplete #countryOfResidence="matAutocomplete" class="custom-mat-autocomplete">
      <mat-option *ngFor="let countryOfResidence of filteredIndividualCountriesOfResidence$ | async" [value]="countryOfResidence" [title]="countryOfResidence">
        {{countryOfResidence}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <!-- End Residence Country formfield -->
  <!-- Start Identification Type formfield -->
  <div class="details-form__field-sub-container">
    <mat-form-field class="custom-mat-form-field details-form__field-sub-select">
      <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
      <mat-select placeholder="{{ 'customer_type.individual.form.label.identity_document_type' | translate }}" formControlName="idType">
        <mat-option *ngFor="let identityDocumentType of identityDocumentTypesList" [value]="identityDocumentType" [title]="identityDocumentType">
          {{identityDocumentType}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="individualFormGroup.get('idType').errors?.incorrect && (individualFormGroup.get('idType').dirty || individualFormGroup.get('idType').touched)">
        <span *ngIf="individualFormGroup.get('idType').errors?.incorrect">
          "{{individualFormGroup.get('idType').value}}" {{ 'customer_type.individual.message.error.identity' | translate }}
        </span>
        <span class="details-form__remove-error-value-label" (click)="removeValue(individualFormGroup.get('idType'))" title="Remove">
          {{ 'customer_type.individual.message.error.remove' | translate }}
        </span>
      </mat-error>
    </mat-form-field>
    <mat-form-field class="custom-mat-form-field details-form__field-sub-textarea" appearance="fill"
                    *ngIf="individualFormGroup.get('idType')?.value === 'OTHERS'">
      <mat-label> {{ 'customer_type.individual.form.label.other_identity_document_type' | translate }} </mat-label>
      <textarea matInput rows="6" formControlName="otherIdType"></textarea>
    </mat-form-field>
  </div>
  <!-- End Identification Type formfield -->
  <!-- Start Identification Number formfield -->
  <mat-form-field class="custom-mat-form-field details-form__field details-form__field_mt_7">
    <input matInput placeholder="{{ 'customer_type.individual.form.label.identity_number' | translate }}" formControlName="idNumber" autocomplete="off">
  </mat-form-field>
  <!-- End Identification Number formfield -->
  <!-- Start Date of Identity Issue formfield -->
  <mat-form-field class="custom-mat-form-field custom-mat-form-field_datepicker details-form__field">
    <input matInput [matDatepicker]="dateOfIdentityIssuePicker" [max]="maxIdentityIssueDate" placeholder="{{ 'customer_type.individual.form.label.date_of_identity_issue' | translate }}"
           formControlName="idIssueDate" (focus)="dateOfIdentityIssuePicker.open()">
    <mat-datepicker-toggle matSuffix [for]="dateOfIdentityIssuePicker"></mat-datepicker-toggle>
    <mat-datepicker #dateOfIdentityIssuePicker [startView]="'multi-year'"></mat-datepicker>
  </mat-form-field>
  <!-- End Date of Identity Issue formfield -->
  <!-- Start Date of Identity Expiry formfield -->
  <mat-form-field class="custom-mat-form-field custom-mat-form-field_datepicker details-form__field">
    <input matInput [matDatepicker]="dateOfIdentityExpiryPicker" [min]="individualFormGroup.value.idIssueDate" [max]="maxIdentityExpiryDate" placeholder="{{ 'customer_type.individual.form.label.date_of_identity_expiry' | translate }}"
           formControlName="idExpiryDate" (focus)="dateOfIdentityExpiryPicker.open()">
    <mat-datepicker-toggle matSuffix [for]="dateOfIdentityExpiryPicker"></mat-datepicker-toggle>
    <mat-datepicker #dateOfIdentityExpiryPicker [startView]="'multi-year'"></mat-datepicker>
  </mat-form-field>
  <!-- End Date of Identity Expiry formfield -->
  <!-- Start Country of Birth formfield -->
  <mat-form-field class="custom-mat-form-field custom-mat-form-field_autocomplete details-form__field">
    <input matInput placeholder="{{ 'customer_type.individual.form.label.country_of_birth' | translate }}" aria-label="Country of Birth" [matAutocomplete]="countryOfBirth" formControlName="countryOfBirth" autocomplete="off">
    <img matSuffix class="custom-mat-autocomplete__arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-autocomplete #countryOfBirth="matAutocomplete" class="custom-mat-autocomplete">
      <mat-option *ngFor="let countryOfBirth of filteredIndividualCountriesOfBirth$ | async" [value]="countryOfBirth" [title]="countryOfBirth">
        {{countryOfBirth}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <!-- End Country of Birth formfield -->
  <!-- Start Industry formfield -->
  <mat-form-field *ngIf="isPrimary" class="custom-mat-form-field custom-mat-form-field_mandatory custom-mat-form-field_autocomplete details-form__field">
    <input matInput placeholder="{{ 'customer_type.individual.form.label.industry' | translate }}" #industryInput="matInput" aria-label="Industry *" [matAutocomplete]="industry" formControlName="industry">
    <img matSuffix class="custom-mat-autocomplete__arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-autocomplete  #industryInfinity="infinityScroll" [infinityScroll]="industriesList" #industry="matAutocomplete" [infinityModel]="industryInput" class="custom-mat-autocomplete">
      <mat-option *ngFor="let industry of industryInfinity.items | async" [value]="industry" [title]="industry">
        {{industry}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <!-- End Industry formfield -->
  <!-- Start Occupation formfield -->
  <mat-form-field *ngIf="isPrimary" class="custom-mat-form-field custom-mat-form-field_mandatory custom-mat-form-field_autocomplete details-form__field">
    <input matInput #occupationInput="matInput" placeholder="{{ 'customer_type.individual.form.label.occupation' | translate }}" aria-label="Occupation *" [matAutocomplete]="occupation" formControlName="occupation">
    <img matSuffix class="custom-mat-autocomplete__arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-autocomplete #occupation="matAutocomplete" class="custom-mat-autocomplete"
      #occupationInfinity="infinityScroll"
      [infinityModel]="occupationInput"
      [infinityScroll]="occupationsList">
      <mat-option *ngFor="let occupation of occupationInfinity.items | async" [value]="occupation" [title]="occupation">
        {{occupation}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <!-- End Occupation formfield -->
  <!-- Start Onboarding Mode formfield -->
  <mat-form-field *ngIf="isPrimary" class="custom-mat-form-field custom-mat-form-field_mandatory details-form__field">
    <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-select placeholder="{{ 'customer_type.individual.form.label.onboarding_mode' | translate }}" formControlName="onboardingMode">
      <mat-option *ngFor="let onboardingMode of onboardingModesList" [value]="onboardingMode" [title]="onboardingMode">
        {{onboardingMode}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- End Onboarding Mode formfield -->
  <!-- Start Payment Mode formfield -->
  <mat-form-field *ngIf="isPrimary" class="custom-mat-form-field custom-mat-form-field_mandatory details-form__field">
    <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-select placeholder="{{ 'customer_type.individual.form.label.payment_mode' | translate }}" formControlName="paymentModes" multiple>
      <mat-option *ngFor="let paymentMode of paymentModesList" [value]="paymentMode" [title]="paymentMode"
                  [disabled]="individualFormGroup.get('paymentModes').value &&
                              ((individualFormGroup.get('paymentModes').value.indexOf('UNKNOWN') >= 0 && paymentMode !== 'UNKNOWN') ||
                               (individualFormGroup.get('paymentModes').value.indexOf('NOT APPLICABLE') >= 0 && paymentMode !== 'NOT APPLICABLE'))">
        {{paymentMode}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- End Payment Mode formfield -->
  <!-- Start Source of Wealth formfield -->
  <mat-form-field *ngIf="isPrimary && isShowSourceOfWealth" class="custom-mat-form-field details-form__field" [ngClass]="{'custom-mat-form-field_mandatory': isRequiredSourceOfWealth}">
    <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-select placeholder="Source Of Wealth" formControlName="sourceOfWealth" [required]="isRequiredSourceOfWealth" multiple>
      <mat-option *ngFor="let sourceOfWealth of sourceOfWealthList" [value]="sourceOfWealth" [title]="sourceOfWealth">
        {{sourceOfWealth}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- End Source of Wealth formfield -->
  <!-- Start Annual Income Level (USD) formfield -->
  <mat-form-field *ngIf="isPrimary && isShowAnnualIncomeLevel" class="custom-mat-form-field custom-mat-form-field_autocomplete details-form__field" [ngClass]="{'custom-mat-form-field_mandatory': isRequiredAnnualIncomeLevel}">
    <input matInput placeholder="Annual Income Level (USD)" aria-label="Annual Income Level (USD)*" [matAutocomplete]="annualIncomeLevelUSD" [required]="isRequiredAnnualIncomeLevel" formControlName="annualIncomeLevel">
    <img matSuffix class="custom-mat-autocomplete__arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-autocomplete #annualIncomeLevelUSD="matAutocomplete" class="custom-mat-autocomplete">
      <mat-option *ngFor="let annualIncomeLevel of filteredIndividualAnnualIncomeLevel$ | async" [value]="annualIncomeLevel" [title]="annualIncomeLevel">
        {{annualIncomeLevel}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <!-- End Annual Income Level (USD) formfield -->
  <!-- Start Product Service Complexity formfield -->
  <mat-form-field *ngIf="isPrimary" class="custom-mat-form-field custom-mat-form-field_mandatory details-form__field">
    <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-select placeholder="{{ 'customer_type.individual.form.label.product_service_complexity' | translate }}" formControlName="productServiceComplexity">
      <mat-option *ngFor="let productServiceComplexity of productServiceComplexitiesList" [value]="productServiceComplexity" [title]="productServiceComplexity">
        {{productServiceComplexity}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- End Product Service Complexity formfield -->
  <!-- Start Source of Funds formfield -->
  <div class="details-form__field-sub-container">
    <mat-form-field class="custom-mat-form-field details-form__field details-form__field-sub-select">
      <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
      <mat-select placeholder="{{ 'customer_type.individual.form.label.source_of_funds' | translate }}" formControlName="sourceOfFunds" #individualSrcOfFunds>
        <mat-option *ngFor="let sourceOfFunds of sourceFundsList" [value]="sourceOfFunds" [title]="sourceOfFunds">
          {{sourceOfFunds}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="individualFormGroup.get('sourceOfFunds').errors?.incorrect && (individualFormGroup.get('sourceOfFunds').dirty || individualFormGroup.get('sourceOfFunds').touched)">
        <span *ngIf="individualFormGroup.get('sourceOfFunds').errors?.incorrect">
          "{{individualFormGroup.get('idType').value}}"{{ 'customer_type.individual.message.error.source_of_funds' | translate }}
        </span>
        <span class="details-form__remove-error-value-label" (click)="removeValue(individualFormGroup.get('sourceOfFunds'))" title="Remove">
          {{ 'customer_type.individual.message.error.remove' | translate }}
        </span>
      </mat-error>
    </mat-form-field>
    <mat-form-field class="custom-mat-form-field details-form__field details-form__field-sub-textarea" appearance="fill"
                    *ngIf="individualFormGroup.get('sourceOfFunds').value === 'OTHERS'">
      <mat-label>{{ 'customer_type.individual.form.label.other_source_of_funds' | translate }}</mat-label>
      <textarea matInput rows="6" formControlName="otherSourceOfFunds"></textarea>
    </mat-form-field>
  </div>
  <!-- End Source of Funds formfield -->
  <!-- Start Date of Birth formfield -->
  <mat-form-field class="custom-mat-form-field custom-mat-form-field_datepicker details-form__field details-form__field_mt_7">
    <input matInput [matDatepicker]="birthdayPicker" [min]="minDoBDate" [max]="maxDoBDate" placeholder="{{ 'customer_type.individual.form.label.date_of_birth' | translate }}"
           formControlName="dateOfBirth" (focus)="birthdayPicker.open()">
    <mat-datepicker-toggle matSuffix [for]="birthdayPicker"></mat-datepicker-toggle>
    <mat-datepicker #birthdayPicker [startView]="'multi-year'"></mat-datepicker>
  </mat-form-field>
  <!-- End Date of Birth formfield -->
  <!-- Start Status formfield -->
  <mat-form-field *ngIf="!isPrimary" class="custom-mat-form-field custom-mat-form-field_mandatory details-form__field">
    <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-select placeholder="{{ 'customer_type.individual.form.label.status' | translate }}" formControlName="status">
      <mat-option *ngFor="let status of statusesList" [value]="status" [title]="status">
        {{status}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- End Status formfield -->
  <!-- Start Customer Reference Number formfield -->
  <mat-form-field *ngIf="isPrimary" class="custom-mat-form-field details-form__field details-form__field_mt_7">
    <img matSuffix class="themified-white-icon details-form__field-info-icon" src="/assets/icons/info-icon.png" matTooltip="Unique ID of this case">
    <input matInput placeholder="{{ 'customer_type.individual.form.label.customer_reference_number' | translate }}" formControlName="customerReferenceId" autocomplete="off">
  </mat-form-field>
  <!-- End Customer Reference Number formfield -->
  <!-- Start Record Reference Number formfield -->
  <mat-form-field class="custom-mat-form-field details-form__field details-form__field_mt_7">
    <img matSuffix class="themified-white-icon details-form__field-info-icon" src="/assets/icons/info-icon.png" matTooltip="Unique ID of this individual/corporate">
    <input matInput placeholder="REFERENCE NUMBER" formControlName="recordReferenceId" autocomplete="off">
  </mat-form-field>
  <!-- End Record Reference Number formfield -->
  <!-- Start Addresses multiple values input -->
  <artemis-multiple-values-input class="details-form__field" name="{{ 'customer_type.individual.form.label.address' | translate }}" formControlName="addresses"
                                 (formSubmitted)="individualFormMultipleValuesInputHandler($event, 'addresses')" #multipleValuesInputComponent>
  </artemis-multiple-values-input>
  <!-- End Addresses multiple values input -->
  <!-- Start Phone numbers multiple values input -->
  <artemis-multiple-values-input class="details-form__field" name="{{ 'customer_type.individual.form.label.phone_number' | translate }}" formControlName="phoneNumbers"
                                 (formSubmitted)="individualFormMultipleValuesInputHandler($event, 'phoneNumbers')" #multipleValuesInputComponent>
  </artemis-multiple-values-input>
  <!-- End Addresses multiple values input -->
  <!-- Start email addresses multiple values input -->
  <artemis-multiple-values-input class="details-form__field" name="{{ 'customer_type.individual.form.label.email_address' | translate }}" formControlName="emailAddresses"
                                 (formSubmitted)="individualFormMultipleValuesInputHandler($event, 'emailAddresses')" #multipleValuesInputComponent>
  </artemis-multiple-values-input>
  <!-- End Addresses multiple values input -->
  <!-- Start Bank accounts multiple values input -->
  <artemis-multiple-values-input class="details-form__field" name="{{ 'customer_type.individual.form.label.bank_account' | translate }}" formControlName="bankAccounts"
                                 (formSubmitted)="individualFormMultipleValuesInputHandler($event, 'bankAccounts')" #multipleValuesInputComponent>
  </artemis-multiple-values-input>
  <!-- End Addresses multiple values input -->
  <!-- Start Premium Amount formfield -->
  <mat-form-field *ngIf="isPrimary && isShowPremiumAmount" class="custom-mat-form-field custom-mat-form-field_mandatory details-form__field" [ngClass]="{'custom-mat-form-field_mandatory': isRequiredPremiumAmount}">
    <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-select placeholder="{{ 'customer_type.individual.form.label.premium_amount' | translate }}" [required]="isRequiredPremiumAmount"  formControlName="premiumAmount">
      <mat-option *ngFor="let premiumAmount of premiumAmountList" [value]="premiumAmount" [title]="premiumAmount">
        {{premiumAmount}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- End Premium Amount formfield -->
  <!-- Start Policy Count formfield -->
  <mat-form-field *ngIf="isPrimary && isShowPolicyCount" class="custom-mat-form-field custom-mat-form-field_mandatory details-form__field" [ngClass]="{'custom-mat-form-field_mandatory': isRequiredPolicyCount}">
    <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-select placeholder="{{ 'customer_type.individual.form.label.policy_count' | translate }}" formControlName="policyCount" [required]="isRequiredPolicyCount">
      <mat-option *ngFor="let policyCount of policyCountList" [value]="policyCount" [title]="policyCount">
        {{policyCount}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- End Policy Count formfield -->
  <!-- Start Business relaionships form field -->
  <mat-form-field *ngIf="isPrimary" appearance="fill" class="custom-mat-form-field details-form__field details-form__field_full-width">
    <mat-label>{{ 'customer_type.individual.form.label.nature_of_business_relationship' | translate }}</mat-label>
    <textarea matInput rows="6" formControlName="natureOfBusinessRelationship"></textarea>
  </mat-form-field>
  <!-- End Business relaionships form field -->
  <!-- Start Is An Undischarged Bankrupt formfield -->
  <div class="details-form__checkbox-container_inline" *ngIf="!isPrimary">
    <mat-checkbox class="custom-mat-checkbox details-form__checkbox" formControlName="isUndischargedBankrupt"></mat-checkbox>
    <span class="details-form__checkbox-label" [ngClass]="{'details-form__checkbox-label_checked': individualFormGroup.get('isUndischargedBankrupt').value}">
      {{ 'customer_type.individual.form.label.is_undischarged_bankrupt' | translate }}
    </span>
  </div>
  <!-- End Is An Undischarged Bankrupt formfield -->
</form>
<!-- End individual details forms -->
<!-- Start corporate details forms -->
<form class="details-form" [formGroup]="corporateFormGroup" [class.details-form_hidden]="customerType !== 'CORPORATE' || !corporateFormGroup">
  <div class="details-form__checkbox-container" *ngIf="isPrimary">
    <mat-checkbox class="custom-mat-checkbox details-form__checkbox" formControlName="isActiveCustomer"></mat-checkbox>
    <span class="details-form__checkbox-label" [ngClass]="{'details-form__checkbox-label_checked': corporateFormGroup.get('isActiveCustomer').value}">
      {{ 'edit_customer.title.customer_is_active' | translate }} <span class="asterisk_mandatory">*</span>
    </span>
  </div>
  <div class="details-form__checkbox-container">
    <mat-checkbox class="custom-mat-checkbox details-form__checkbox" formControlName="isIncorporated"></mat-checkbox>
    <span class="details-form__checkbox-label" [ngClass]="{'details-form__checkbox-label_checked': corporateFormGroup.get('isIncorporated').value}">
      {{ 'edit_customer.title.company_has_been_incorporated' | translate }} <span class="asterisk_mandatory">*</span>
    </span>
  </div>
  <!-- Start Name formfield -->
  <mat-form-field class="custom-mat-form-field custom-mat-form-field_mandatory details-form__field details-form__field_full-width"
                  *ngIf="!isSearch; else corporateExistingRecord;">
    <input matInput placeholder="{{ 'customer_type.corporate.form.label.company_name' | translate }}" formControlName="name" autocomplete="off">
  </mat-form-field>
  <ng-template #corporateExistingRecord>
    <mat-form-field class="custom-mat-form-field custom-mat-form-field_mandatory details-form__field details-form__field_full-width" *ngIf="customerType === 'CORPORATE'">
      <input matInput #corporateNameInput='matInput' placeholder="{{ 'customer_type.corporate.form.label.company_name' | translate }}" formControlName="name" [matAutocomplete]="corporateName" [ngClass]="{'details-form__input_with-remove-btn': showRemoveBtn}">
      <button mat-button ubi-round-button class="btn btn_rounded remove-search-btn" *ngIf="showRemoveBtn" (click)="removeSelectedCustomer()">
        {{ 'customer_type.button.clear_selected_profile' | translate }}
      </button>
      <mat-autocomplete class="custom-mat-autocomplete search-name-autocomplete" #corporateNameInfinity="infinityScroll" #corporateName="matAutocomplete" [infinityModel]="corporateNameInput" [infinityScroll]="recordsSuggest" (scrollRecordSearch)="onScroll($event)" [isRecordSearch]="true">
        <div class="search-option__hint" *ngIf="recordsSuggest && recordsSuggest.length">
          {{ 'customer_type.corporate.text' | translate }}
        </div>
        <mat-option *ngFor="let record of corporateNameInfinity.items | async" [value]="record.name" (onSelectionChange)="optionSelected(record)">
          <div class="search-option__content">
            <div class="search-option__item">
              <label class="search-option__item-label"> {{ 'customer_type.corporate.dropdown.company_name' | translate }} </label>
              <span class="search-option__item-text">{{record.name}}</span>
            </div>
            <div class="search-option__group">
              <div class="search-option__item search-option__group-item">
                <label class="search-option__item-label"> {{ 'customer_type.corporate.dropdown.formerly_known_as' | translate }} </label>
                <span class="search-option__item-text">{{record.oldNames.length ? record.oldNames.join(', ') : '-'}}</span>
              </div>
              <div class="search-option__item search-option__group-item">
                <label class="search-option__item-label"> {{ 'customer_type.corporate.dropdown.reference_id' | translate }} </label>
                <span class="search-option__item-text">{{record.referenceId !== '' ? record.referenceId : '-'}}</span>
              </div>
            </div>
            <button mat-button ubi-round-button class="btn btn_accent-gradient-rounded btn-profile">
              {{ 'customer_type.corporate.dropdown.use_this_profile' | translate }}
            </button>
          </div>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </ng-template>
  <!-- End Name formfield -->
  <!-- Start Alias Name multiple values input -->
  <artemis-multiple-values-input class="details-form__field" name="{{ 'customer_type.corporate.form.label.alias_name' | translate }}" formControlName="aliasNames"
                                 (formSubmitted)="corporateFormMultipleValuesInputHandler($event, 'aliasNames')" #multipleValuesInputComponent>
  </artemis-multiple-values-input>
  <!-- End Alias Name multiple values input -->
  <!-- Start Former Registered Name multiple values input -->
  <artemis-multiple-values-input class="details-form__field" name="{{ 'customer_type.corporate.form.label.former_registered_name' | translate }}" formControlName="oldNames"
                                 (formSubmitted)="corporateFormMultipleValuesInputHandler($event, 'oldNames')" #multipleValuesInputComponent>
  </artemis-multiple-values-input>
  <!-- End Former Registered Name multiple values input -->
  <!-- Start Entity formfield -->
  <mat-form-field class="custom-mat-form-field custom-mat-form-field_mandatory details-form__field">
    <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-select placeholder="{{ 'customer_type.corporate.form.label.entity_type' | translate }}" formControlName="entityType">
      <mat-option *ngFor="let entityType of entityTypesList" [value]="entityType" [title]="entityType">
        {{entityType}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- End Entity formfield -->
  <!-- Start Structures formfield -->
  <mat-form-field class="custom-mat-form-field custom-mat-form-field_mandatory details-form__field">
    <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-select placeholder="{{ 'customer_type.corporate.form.label.ownership_structure_layer' | translate }}" formControlName="ownershipStructureLayers">
      <mat-option *ngFor="let ownershipStructure of ownershipStructureLayersList" [value]="ownershipStructure" [title]="ownershipStructure">
        {{ownershipStructure}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- End Structures formfield -->
  <!-- Start Country of incorporation formfield -->
  <mat-form-field class="custom-mat-form-field custom-mat-form-field_mandatory custom-mat-form-field_autocomplete details-form__field">
    <input matInput placeholder="{{ 'customer_type.corporate.form.label.country_of_incorporation' | translate }}" aria-label="Country of Incorporation *"
           [matAutocomplete]="countryOfIncorporations" formControlName="countryOfIncorporation">
    <img matSuffix class="custom-mat-autocomplete__arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-autocomplete #countryOfIncorporations="matAutocomplete" class="custom-mat-autocomplete">
      <mat-option *ngFor="let countryOfIncorporation of filteredCorporateCountriesOfResidence$ | async" [value]="countryOfIncorporation" [title]="countryOfIncorporation">
        {{countryOfIncorporation}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <!-- End Country of incorporation formfield -->
  <!-- Start Country of Major Operation formfield -->
  <mat-form-field class="custom-mat-form-field custom-mat-form-field_mandatory custom-mat-form-field_autocomplete details-form__field">
    <input matInput placeholder="{{ 'customer_type.corporate.form.label.country_of_major_operation' | translate }}" aria-label="Country of Major Operation *" [matAutocomplete]="countryOfOperations" formControlName="countryOfOperations">
    <img matSuffix class="custom-mat-autocomplete__arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-autocomplete #countryOfOperations="matAutocomplete" class="custom-mat-autocomplete">
      <mat-option *ngFor="let countryOfOperation of filteredCorporateOperationsCountries$ | async" [value]="countryOfOperation" [title]="countryOfOperation">
        {{countryOfOperation}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <!-- End Country of Major Operation formfield -->
  <!-- Start Date of Incorporation formfield -->
  <mat-form-field class="custom-mat-form-field custom-mat-form-field_datepicker details-form__field">
    <input matInput [matDatepicker]="dateOfIncorporationPicker" [max]="maxIncorporationDate" placeholder="{{ 'customer_type.corporate.form.label.date_of_incorporation' | translate }}"
           formControlName="incorporationDate" (focus)="dateOfIncorporationPicker.open()">
    <mat-datepicker-toggle matSuffix [for]="dateOfIncorporationPicker"></mat-datepicker-toggle>
    <mat-datepicker #dateOfIncorporationPicker [startView]="'multi-year'"></mat-datepicker>
  </mat-form-field>
  <!-- End Date of Incorporation formfield -->
  <!-- Start Date of Incorporation Expiry formfield -->
  <mat-form-field class="custom-mat-form-field custom-mat-form-field_datepicker details-form__field">
    <input matInput [matDatepicker]="dateOfIncorporationExpiryPicker" [min]="corporateFormGroup.value.incorporationDate" placeholder="{{ 'customer_type.corporate.form.label.date_of_incorporation_expiry' | translate }}"
           formControlName="incorporationExpiryDate" (focus)="dateOfIncorporationExpiryPicker.open()">
    <mat-datepicker-toggle matSuffix [for]="dateOfIncorporationExpiryPicker"></mat-datepicker-toggle>
    <mat-datepicker #dateOfIncorporationExpiryPicker [startView]="'multi-year'"></mat-datepicker>
  </mat-form-field>
  <!-- End Date of Incorporation Expiry formfield -->
  <!-- Start Is Ultimate Holding Company in FATF Jurisdiction formfield -->
  <div *ngIf="isPrimary" class="details-form__checkbox-container_inline">
    <mat-checkbox class="custom-mat-checkbox details-form__checkbox" formControlName="inFatfJurisdiction"></mat-checkbox>
    <span class="details-form__checkbox-label" [ngClass]="{'details-form__checkbox-label_checked': corporateFormGroup.get('inFatfJurisdiction').value}">
      {{ 'customer_type.corporate.form.label.is_uhc_fatf_jurisdiction' | translate }}
    </span>
  </div>
  <!-- End Is Ultimate Holding Company in FATF Jurisdiction formfield-->
  <!-- Start Primary Business Activity formfield -->

  <mat-form-field *ngIf="isPrimary" class="custom-mat-form-field custom-mat-form-field_mandatory custom-mat-form-field_autocomplete details-form__field">
    <input matInput #primaryBusinessActivityInput="matInput"  placeholder="{{ 'customer_type.corporate.form.label.primary_business_activity' | translate }}" aria-label="Primary Business Activity *" [matAutocomplete]="primaryBusinessActivity" formControlName="businessActivity">
    <img matSuffix class="custom-mat-autocomplete__arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-autocomplete class="custom-mat-autocomplete" #primaryBusinessActivity="matAutocomplete"
    #primaryBusinessActivityInfinity="infinityScroll"
    [infinityModel]="primaryBusinessActivityInput"
    [infinityScroll]="industriesList"
    >
      <mat-option *ngFor="let primaryBusinessActivity of primaryBusinessActivityInfinity.items | async" [value]="primaryBusinessActivity" [title]="primaryBusinessActivity">
        {{primaryBusinessActivity}}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <!-- End Primary Business Activity formfield -->
  <!-- Start Onboarding mode formfield -->
  <mat-form-field *ngIf="isPrimary" class="custom-mat-form-field custom-mat-form-field_mandatory details-form__field">
    <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-select placeholder="{{ 'customer_type.corporate.form.label.onboarding_mode' | translate }}" formControlName="onboardingMode">
      <mat-option *ngFor="let onboardingMode of onboardingModesList" [value]="onboardingMode" [title]="onboardingMode">
        {{onboardingMode}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- End Onboarding mode formfield -->
  <!-- Start Payment Mode formfield -->
  <mat-form-field *ngIf="isPrimary" class="custom-mat-form-field custom-mat-form-field_mandatory details-form__field">
    <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-select placeholder="{{ 'customer_type.corporate.form.label.payment_mode' | translate }}" formControlName="paymentModes" multiple>
      <mat-option *ngFor="let paymentMode of paymentModesList" [value]="paymentMode" [title]="paymentMode"
                  [disabled]="corporateFormGroup.get('paymentModes').value &&
                              ((corporateFormGroup.get('paymentModes').value.indexOf('UNKNOWN') >= 0 && paymentMode !== 'UNKNOWN') ||
                               (corporateFormGroup.get('paymentModes').value.indexOf('NOT APPLICABLE') >= 0 && paymentMode !== 'NOT APPLICABLE'))">
        {{paymentMode}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- End Payment Mode formfield -->
  <!-- Start Source of funds formfield -->
  <mat-form-field *ngIf="isPrimary" class="custom-mat-form-field custom-mat-form-field_mandatory details-form__field">
    <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-select placeholder="{{ 'customer_type.corporate.form.label.product_service_complexity' | translate }}" formControlName="productServiceComplexity">
      <mat-option *ngFor="let productServiceComplexity of productServiceComplexitiesList" [value]="productServiceComplexity" [title]="productServiceComplexity">
        {{productServiceComplexity}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- End Payment Mode formfield -->
  <!-- Start Source of funds formfield -->
  <div class="details-form__field-sub-container">
    <mat-form-field class="custom-mat-form-field details-form__field-sub-select">
      <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
      <mat-select placeholder="{{ 'customer_type.corporate.form.label.source_of_funds' | translate }}" formControlName="sourceOfFunds" #corporateSrcOfFunds>
        <mat-option *ngFor="let sourceOfFunds of sourceFundsList" [value]="sourceOfFunds" [title]="sourceOfFunds">
          {{sourceOfFunds}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="corporateFormGroup.get('sourceOfFunds').errors?.incorrect && (corporateFormGroup.get('sourceOfFunds').dirty || corporateFormGroup.get('sourceOfFunds').touched)">
        <span *ngIf="corporateFormGroup.get('sourceOfFunds').errors?.incorrect">
          "{{corporateFormGroup.get('sourceOfFunds').value}}" {{ 'customer_type.corporate.message.error.source_of_funds' | translate }}
        </span>
        <span class="details-form__remove-error-value-label" (click)="removeValue(corporateFormGroup.get('sourceOfFunds'))" title="Remove">
          {{ 'customer_type.corporate.message.remove' | translate }}
        </span>
      </mat-error>
    </mat-form-field>
    <mat-form-field class="custom-mat-form-field details-form__field-sub-textarea" appearance="fill" *ngIf="corporateFormGroup.get('sourceOfFunds').value === 'OTHERS'">
      <mat-label> {{ 'customer_type.corporate.form.label.other_source_of_funds' | translate }} </mat-label>
      <textarea matInput rows="6" formControlName="otherSourceOfFunds"></textarea>
    </mat-form-field>
  </div>
  <!-- End Source of funds formfield -->
  <!-- Start Incorporation Number formfield -->
  <mat-form-field class="custom-mat-form-field details-form__field details-form__field_mt_7">
    <input matInput placeholder="{{ 'customer_type.corporate.form.label.incorporation_number' | translate }}" formControlName="incorporationNumber" autocomplete="off">
  </mat-form-field>
  <!-- End Incorporation Number formfield -->
  <!-- Start IMO Number formfield -->
  <mat-form-field class="custom-mat-form-field details-form__field details-form__field_mt_7">
    <input matInput placeholder="{{ 'customer_type.corporate.form.label.imo_number' | translate }}" formControlName="imoNumber" autocomplete="off">
  </mat-form-field>
  <!-- End IMO Number formfield -->
  <!-- Start Website formfield -->
  <mat-form-field class="custom-mat-form-field details-form__field details-form__field_mt_7">
    <input matInput placeholder="{{ 'customer_type.corporate.form.label.website' | translate }}" formControlName="website" autocomplete="off">
  </mat-form-field>
  <!-- End Website formfield -->
  <!-- Start Status formfield -->
  <mat-form-field *ngIf="!isPrimary" class="custom-mat-form-field custom-mat-form-field_mandatory details-form__field">
    <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-select placeholder="{{ 'customer_type.corporate.form.label.status' | translate }}" formControlName="status">
      <mat-option *ngFor="let status of statusesList" [value]="status" [title]="status">
        {{status}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- End Status formfield -->
  <!-- Start Customer Reference Number formfield -->
  <mat-form-field *ngIf="isPrimary" class="custom-mat-form-field details-form__field details-form__field_mt_7">
    <img matSuffix class="themified-white-icon details-form__field-info-icon" src="/assets/icons/info-icon.png" matTooltip="Unique ID of this case">
    <input matInput placeholder="{{ 'customer_type.corporate.form.label.customer_reference_number' | translate }}" formControlName="customerReferenceId" autocomplete="off">
  </mat-form-field>
  <!-- End Customer Reference Number formfield -->
  <!-- Start Record Reference Number formfield -->
  <mat-form-field class="custom-mat-form-field details-form__field details-form__field_mt_7">
    <img matSuffix class="themified-white-icon details-form__field-info-icon" src="/assets/icons/info-icon.png" matTooltip="Unique ID of this individual/corporate">
    <input matInput placeholder="REFERENCE NUMBER" formControlName="recordReferenceId" autocomplete="off">
  </mat-form-field>
  <!-- End Record Reference Number formfield -->
  <!-- Start Addresses multiple values input -->
  <artemis-multiple-values-input class="details-form__field" name="{{ 'customer_type.corporate.form.label.address' | translate }}" formControlName="addresses"
                                 (formSubmitted)="corporateFormMultipleValuesInputHandler($event, 'addresses')" #multipleValuesInputComponent>
  </artemis-multiple-values-input>
  <!-- End Addresses multiple values input -->
  <!-- Start Phone numbers multiple values input -->
  <artemis-multiple-values-input class="details-form__field" name="{{ 'customer_type.corporate.form.label.phone_number' | translate }}" formControlName="phoneNumbers"
                                 (formSubmitted)="corporateFormMultipleValuesInputHandler($event, 'phoneNumbers')" #multipleValuesInputComponent>
  </artemis-multiple-values-input>
  <!-- End Addresses multiple values input -->
  <!-- Start Email addresses multiple values input -->
  <artemis-multiple-values-input class="details-form__field" name="{{ 'customer_type.corporate.form.label.email_address' | translate }}" formControlName="emailAddresses"
                                 (formSubmitted)="corporateFormMultipleValuesInputHandler($event, 'emailAddresses')" #multipleValuesInputComponent>
  </artemis-multiple-values-input>
  <!-- End Email Addresses multiple values input -->
  <!-- Start Bank Accounts multiple values input -->
  <artemis-multiple-values-input class="details-form__field" name="{{ 'customer_type.corporate.form.label.bank_account' | translate }}" formControlName="bankAccounts"
                                 (formSubmitted)="corporateFormMultipleValuesInputHandler($event, 'bankAccounts')" #multipleValuesInputComponent>
  </artemis-multiple-values-input>
  <!-- End Bank Accounts multiple values input -->
  <!-- Start Premium Amount formfield -->
  <mat-form-field *ngIf="isPrimary && isShowPremiumAmount" class="custom-mat-form-field custom-mat-form-field_mandatory details-form__field" [ngClass]="{'custom-mat-form-field_mandatory': isRequiredPremiumAmount}">
    <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-select placeholder="{{ 'customer_type.corporate.form.label.premium_amount' | translate }}" [required]="isRequiredPremiumAmount" formControlName="premiumAmount">
      <mat-option *ngFor="let premiumAmount of premiumAmountList" [value]="premiumAmount" [title]="premiumAmount">
        {{premiumAmount}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- End Premium Amount formfield -->
  <!-- Start Policy Count formfield -->
  <mat-form-field *ngIf="isPrimary && isShowPolicyCount" class="custom-mat-form-field custom-mat-form-field_mandatory details-form__field" [ngClass]="{'custom-mat-form-field_mandatory': isRequiredPolicyCount}">
    <img matSuffix class="custom-mat-form-field__select-arrow-icon" src="/assets/icons/chevron-down-icon.png">
    <mat-select placeholder="{{ 'customer_type.corporate.form.label.policy_count' | translate }}" [required]="isRequiredPolicyCount" formControlName="policyCount">
      <mat-option *ngFor="let policyCount of policyCountList" [value]="policyCount" [title]="policyCount">
        {{policyCount}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <!-- End Policy Count formfield -->
  <mat-form-field class="custom-mat-form-field details-form__field details-form__field_full-width" *ngIf="isPrimary" appearance="fill">
    <mat-label> {{ 'customer_type.corporate.form.label.nature_of_business_relationship' | translate }} </mat-label>
    <textarea matInput rows="6" formControlName="natureOfBusinessRelationship"></textarea>
  </mat-form-field>
  <!-- End Business relaionships form field -->
  <!-- Start Is An Undischarged Bankrupt formfield -->
  <div class="details-form__checkbox-container_inline" *ngIf="!isPrimary">
    <mat-checkbox class="custom-mat-checkbox details-form__checkbox" formControlName="isUndischargedBankrupt"></mat-checkbox>
    <span class="details-form__checkbox-label" [ngClass]="{'details-form__checkbox-label_checked': corporateFormGroup.get('isUndischargedBankrupt').value}">
      {{ 'customer_type.corporate.form.label.is_undischarged_bankrupt' | translate }}
    </span>
  </div>
  <!-- End Is An Undischarged Bankrupt formfield -->
</form>
<!-- End corporate details forms -->
<!-- End forms -->
